import styled from 'styled-components';

import { colors, radius } from '../../../../../../styles/tokens';

export const Container = styled.div`
  display: flex;
  align-items: stretch;

  background-color: ${colors.surfaceContainerLow};
  border-radius: ${radius.DEFAULT};
  overflow: hidden;

  transition: transform 0.2s;

  &:hover {
    transform: translateX(4px);
  }
`;

export const AccentBar = styled.div`
  width: 4px;
  background-color: ${colors.primary};
  flex-shrink: 0;
`;

export const Content = styled.div`
  flex: 1;
  padding: 20px;
`;

export const MainRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const InfoGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const DragHandle = styled.div`
  color: ${colors.onSurfaceVariant};
  cursor: grab;
  display: flex;

  &:active {
    cursor: grabbing;
  }
`;

export const ExerciseTitle = styled.h4`
  font-size: 15px;
  font-weight: 700;
  color: ${colors.onSurface};
  line-height: 1.2;
`;

export const ExerciseSubtitle = styled.p`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.onSurfaceVariant};
  margin-top: 2px;
`;

export const FieldsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const FieldGroup = styled.div`
  text-align: center;
`;

export const FieldLabel = styled.p`
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${colors.onSurfaceVariant};
  margin-bottom: 4px;
`;

interface FieldInputProps {
  width?: number;
}

export const FieldInput = styled.input<FieldInputProps>`
  width: ${({ width }) => width || 56}px;

  padding: 4px;
  text-align: center;

  background-color: ${colors.surfaceContainerHigh};
  border: none;
  border-radius: ${radius.sm};

  color: ${colors.onSurface};
  font-size: 13px;
  font-weight: 700;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 1px ${colors.primary};
  }
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 6px;

  background: transparent;
  border: none;
  cursor: pointer;

  color: ${colors.onSurfaceVariant};

  &:hover {
    color: ${colors.error};
  }
`;

export const NotesInput = styled.textarea`
  width: 100%;
  margin-top: 8px;

  background: transparent;
  border: none;
  resize: none;

  color: ${colors.onSurfaceVariant};
  font-size: 12px;
  font-style: italic;
  font-family: inherit;

  &::placeholder {
    color: ${colors.onSurfaceVariant}80;
  }

  &:focus {
    outline: none;
  }
`;
